// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"C52oEZ7lz4R1GUsGeglt","container":"J5kg_Ke_pN71ayLESJHI"};